/***
 *
 * Return the URL that contains a video metadata
 * @param { Number | string } contentId - id of the video
 *
 */
export function getMetadataURL(mediaConfig, slug = '', locale = 'en') {

    const {
        metadataServiceBase,
    } = mediaConfig;

    return `${metadataServiceBase}/data-service/${locale}/videos/${slug}`;

}
